export default "__VITE_ASSET__Cw51V51d__"